import { SelfAccountUnlockFormFields } from 'src/constants';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { useState } from 'react';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import ToastMessage from '../../common/ToastMessage';

const useSelfAccountUnlock = () => {
  const [initialFormData, setInitialFormData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isServerError, setIsServerError] = useState(false);
  const [selfUnlockAccountOid, setSelfUnlockAccountOid] = useState('');
  const [resetOptionOid, setResetOptionOid] = useState('');
  const schema = yup.object({
    MaxUnlockAttempts: yup
      .string()
      .required('Please enter maximum Unlock Attempts'),
    CoolOffPeriod: yup
      .string()
      .required('Please enter cool off period in minutes.'),
  });

  const identificationFields = SelfAccountUnlockFormFields.reduce(
    (acc, curr) => {
      acc[curr.value] = 'yes'; //or any value you want
      return acc;
    },
    {},
  );

  const getIdentificationFields = (data) => {
    //console.log('...identificationFields', data);
    const result = {};

    SelfAccountUnlockFormFields.forEach((field) => {
      let obj1Key;
      switch (field.value.toLowerCase()) {
        case 'fname':
          obj1Key = 'FirstName';
          break;
        case 'lname':
          obj1Key = 'LastName';
          break;
        case 'ssn':
          obj1Key = 'SocialSecurityNumber';
          break;
        case 'dob':
          obj1Key = 'DateOfBirth';
          break;
        case 'altid1':
          obj1Key = 'AlternateID1';
          break;
        case 'altid2':
          obj1Key = 'AlternateID2';
          break;
        case 'medicareid':
          obj1Key = 'MedicareID';
          break;
        case 'postalcode':
          obj1Key = 'PostalCode';
          break;
        case 'relationship':
          obj1Key = 'Relationship';
          break;
        case 'altemail':
          obj1Key = 'Email';
          break;
        case 'phonenumber':
          obj1Key = 'PhoneNumber';
          break;
        case 'certificatenumber':
          obj1Key = 'CertificateNumber';
          break;
        default:
          obj1Key = null;
      }

      if (obj1Key && data[obj1Key] !== undefined) {
        result[field.value] = data[obj1Key]; //keep "Visible"/"InVisible"
      } else {
        result[field.value] = 'InVisible'; //default if not found
      }
    });
    setResetOptionOid(data?.OID);
    console.log('...result', result);
    return result;
  };

  const fetchConfigData = async () => {
    setIsLoading(true);
    try {
      const responseConfiguration = await axiosInstance.get(
        APIEndpoints.getAdminConfigResources(),
      );
      const accountUnlockConfig =
        responseConfiguration?.data?.Response?.AccountUnLockConfiguration;
      const accountUnlockOptions =
        responseConfiguration?.data?.Response?.ResetOptions?.filter(
          (item) => item.RecordType === 'SAUnlock',
        );
      const identificationFields = getIdentificationFields(
        accountUnlockOptions[0],
      );
      const initialData = {
        EnableSelfUnlock: accountUnlockConfig?.EnableSelfUnlock,
        MemberEligiblePersonas: accountUnlockConfig?.MemberEnabled,
        DependentEligiblePersonas: accountUnlockConfig?.DependentEnabled,
        otp: accountUnlockConfig?.OtpRequired,
        MaxUnlockAttempts: accountUnlockConfig?.MaxUnlockAttempts,
        CoolOffPeriod: accountUnlockConfig?.CooloffPeriodMinutes,
        ForcePassword: accountUnlockConfig?.ForcePasswordReset,
        SelfAccountUnlockDisclaimer: accountUnlockConfig?.Disclaimer,
        ...identificationFields,
      };
      setInitialFormData(initialData);
      setSelfUnlockAccountOid(accountUnlockConfig?.Oid);
      //console.log(
      'value..',
        responseConfiguration,
        initialData,
        identificationFields,
        //);
        setIsLoading(false);
    } catch (e) {
      setIsServerError(true);
      setIsLoading(false);
      //console.log(e);
    }
  };

  const saveData = async (data) => {
    try {
      console.log('save data...', data);
      const accountUnlockdata = {
        Oid: selfUnlockAccountOid,
        EnableSelfUnlock: data?.EnableSelfUnlock,
        DependentEnabled: data?.DependentEligiblePersonas,
        MemberEnabled: data?.MemberEligiblePersonas,
        OtpRequired: data?.otp,
        MaxUnlockAttempts: data?.MaxUnlockAttempts,
        CooloffPeriodMinutes: data?.CoolOffPeriod,
        ForcePasswordReset: data?.ForcePassword,
        Disclaimer: data?.SelfAccountUnlockDisclaimer,
      };

      const resetOption = {
        OID: resetOptionOid,
        RecordType: 'SAUnlock',
        Disclaimer: data?.SelfAccountUnlockDisclaimer,
        AllowRecoveryUsingAltMail: 'YES',
        FirstName: data?.fname,
        LastName: data?.lname,
        DateOfBirth: data?.dob,
        Email: data?.altemail,
        PostalCode: data?.postalcode,
        Relationship: data?.relationship,
        PhoneNumber: data?.phonenumber,
        SocialSecurityNumber: data?.ssn,
        CertificateNumber: data?.certificatenumber,
        AlternateID1: data?.altid1,
        AlternateID2: data?.altid2,
        MedicareID: data?.medicareid,
      };
      const payload = {
        AccountUnLockConfiguration: accountUnlockdata,
        ResetOptions: [resetOption],
      };
      //console.log('payload...', payload);
      const response = await axiosInstance.put(
        APIEndpoints.putAdminConfigResources(),
        payload,
      );
      toast.success(
        <ToastMessage
          type="success"
          subTitle={'Configuration updated successfully'}
        />,
      );
    } catch (e) {
      <ToastMessage type="success" subTitle={'Configuration update failed'} />;
    }
  };

  useState(() => {
    fetchConfigData();
  }, []);
  return {
    SelfAccountUnlockFormFields,
    initialFormData,
    schema,
    isServerError,
    isLoading,
    saveData,
  };
};

export default useSelfAccountUnlock;
